/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Property_Applied_A_To_BInputs */



/**
* | output |
* | --- |
* | "Property applied from Group A to Group B" |
*
* @param {Compare_Event_Groups_Property_Applied_A_To_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_property_applied_a_to_b = /** @type {((inputs?: Compare_Event_Groups_Property_Applied_A_To_BInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Property_Applied_A_To_BInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Propriété appliquée du groupe A au groupe B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Eigentum, das von Gruppe A auf Gruppe B übertragen wurde")
	if (locale === "it") return /** @type {LocalizedString} */ ("Proprietà applicata dal Gruppo A al Gruppo B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Имущество, перенесенное из группы А в группу В.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Propiedad aplicada del Grupo A al Grupo B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("从A组到B组的属性")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループAからグループBに適用される資産")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह A से समूह B में स्थानांतरित की गई संपत्ति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Propriedade transferida do Grupo A para o Grupo B")
	return /** @type {LocalizedString} */ ("Property applied from Group A to Group B")
});